

import LookupCard from './lookup-card';

/**
  Events:
  kiosks:selected -> when an kiosk is picked, it passes the kiosk back to the caller
  */

export default class CostcodeLookupCard extends LookupCard
{
  constructor()
  {
    super({ title: 'Cost Codes' });
  };

  get fetchURI()
  {
    return `/lookup/companies/${this.company.value}/costcodes`;
  }

  get listConfig()
  {
    return {
      columns: [
        { label: 'Cost Code', value: 'label' },
      ],
      //fetch: this.fetchApi,
      valueField: 'id',
      focusable: true,
      method: 'post',
      options: [],
      click: (item, row) => {},
      filters: [
        { type: 'text', name: 'search_string', placeholder: 'Search Cost Codes', static: true },
      ]
    };

  };

  handleSelected(evt)
  {
    this.triggerHammer(evt, evt.detail.model.cost_code_formatted);
  };


}

customElements.define('costcode-lookup-card',CostcodeLookupCard);

